import React, { Fragment, useState } from 'react';
import styles from './thirdPartyQuestionnarieSidebar.module.css';
import InstaBrainLogo from '../../../Assets/ib_color.png';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { ICategoriesTree } from "../../../Models/thirdPartyQuestionnarieModels";

interface IQuestionDetailFromSubSectionDetail {
    label: string;
    id: string;
}

export interface ISubSectionDetail {
    subSectionName: string;
    subSectionId: string;
    questions: IQuestionDetailFromSubSectionDetail[];
}

export interface ISectionDetails {
    sectionName: string;
    sectionId: string;
    subSections: ISubSectionDetail[];
}

interface IThirdPartyQuestionnarieSidebar {
    sections: ICategoriesTree[];
}

const ThirdPartyQuestionnaireSidebar = (props: IThirdPartyQuestionnarieSidebar) => {
    return (
        <Fragment>
            <div className={styles.sidebar_outer}>
                <img src={InstaBrainLogo} alt={"instabrain"} className={styles.instabrain_logo} />
                <div className={styles.sidebar_content}>
                    <div className={styles.sidebar_header}>
                        <h4>Form Details</h4>
                    </div>
                    <div className={styles.sidebar_form_sections}>
                        {
                            props.sections.sort((a, b) => a.sequenceNo - b.sequenceNo).map((value, index) => {
                                return (
                                    <SectionDetailFromThirdPartyQuestionnaireSidebar section={value} key={index} />
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

interface ISectionDetailFromThirdPartyQuestionnaireSidebar {
    section: ICategoriesTree;
}

const SectionDetailFromThirdPartyQuestionnaireSidebar = (props: ISectionDetailFromThirdPartyQuestionnaireSidebar) => {
    const [flagOpen, setFlagOpen] = useState(true);

    const UpdateFlagOpen = () => {
        setFlagOpen(!flagOpen)
    }

    const GoToSectionOrQuestion = (id: string) => {
        window.location.href = `${window.location.href.split("#")[0]}#${id}`
    }

    return (
        <div className={styles.section_outer}>
            <div className={styles.section_detail} onClick={UpdateFlagOpen}>
                {
                    flagOpen ?
                        <ArrowDropDownIcon /> :
                        <ArrowRightIcon />
                }
                <span onClick={() => GoToSectionOrQuestion(props.section.categoryId)}>{props.section.categoryName}</span>
            </div>
            {
                flagOpen &&
                <div className={styles.subSection_outer}>
                    {
                        props.section.subCategories.sort((a, b) => a.sequenceNo - b.sequenceNo).map((value) => {
                            return (
                                <span onClick={() => GoToSectionOrQuestion(value.subCategoryId)} className={styles.subSection} key={value.subCategoryId}>{value.subCategoryName}</span>
                            )
                        })
                    }
                </div>
            }
        </div>
    )
}

export default ThirdPartyQuestionnaireSidebar;